import React from "react";
import * as Styles from "../../../../common-deprecated/styles/v2/toyota/components/Form";
import { IconExclamation } from "../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { IconWrapper } from "../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import type { TradeInAemDetailFormItem } from "../../../utils/types";
import useValidatedTextField from "../../../../common-deprecated/hooks/useValidatedTextField";
import { useTradeInAemLabel } from "../../../utils/labels";
import { useTradeInCsl } from "../../../csl/tradeInCslUtils";
import {
    formatVehicleDetailsTextField,
    getHardValidationRule,
    getHtmlInputTypeFromFormType,
} from "../../../utils/utils";

type Props = { formItem: TradeInAemDetailFormItem; formItemKey: string; showRequiredError?: boolean };

const VehicleDetailsTextField = ({ formItem, formItemKey, showRequiredError = false }: Props): JSX.Element | null => {
    const { type, label, description, placeholder, required } = formItem;
    const csl = useTradeInCsl();
    const requiredLabel = useTradeInAemLabel("tradeInAemFieldRequired");
    const { errorMessage, value, setValue } = useValidatedTextField(
        formItem.value as string,
        (newValue) => csl.setFormItemValue(formItemKey, newValue),
        {
            showRequiredError,
            requiredLabel,
            required: formItem.required,
            validationRule: formItem.validationRule,
            validationError: formItem.validationError,
            hardValidationRule: getHardValidationRule(type),
        },
    );

    return (
        <>
            <Styles.InputField hasError={!!errorMessage} mt={2}>
                <Styles.InputLabel htmlFor={formItemKey}>
                    {label}
                    {required && <Styles.MandatoryField largeFontSize>*</Styles.MandatoryField>}
                </Styles.InputLabel>
                <Styles.Input>
                    <input
                        type={getHtmlInputTypeFromFormType(type)}
                        id={formItemKey}
                        placeholder={placeholder}
                        required={required}
                        value={formatVehicleDetailsTextField(value, type)}
                        onChange={(event) => {
                            setValue(event.target.value);
                        }}
                    />
                </Styles.Input>
            </Styles.InputField>
            {description && <Styles.HelpText>{description}</Styles.HelpText>}
            {!!errorMessage && (
                <Styles.ErrorField>
                    <span>{errorMessage}</span>
                    <IconWrapper iconColor="primaryRed">
                        <IconExclamation />
                    </IconWrapper>
                </Styles.ErrorField>
            )}
        </>
    );
};

export default VehicleDetailsTextField;
